// The logged-in admin's role comes from the user saved at login.
// The backend still enforces it; this only hides actions that would 403.
export const isSuperAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}").role === "super_admin";
  } catch {
    return false;
  }
};
